import { render, staticRenderFns } from "./HomeForm.vue?vue&type=template&id=a1ff0960&"
import script from "./HomeForm.vue?vue&type=script&lang=js&"
export * from "./HomeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports